<template>
    <b-card>
        <b-modal id="update-tonnage" title="Güncelle" no-close-on-esc no-close-on-backdrop>
            <update-tonnage v-model="UpdateTonnage"></update-tonnage>
            <template #modal-footer><v-executer :loading="updateTonnageLoading" :action="updateTonnage">Güncelle</v-executer></template>
        </b-modal>
        <div class="row">
            <div class="col-md-4 mb-1">
                <label class="form-label">Tarih Aralığı</label>
                <v-date-picker v-model="date" range placeholder="Tarih Aralığı"></v-date-picker>        
            </div>
            <div class="col-md-4 mb-1">
                <label class="form-label">Taşımacı Cari</label>
                <v-select-list v-model="cari" :options="cariList" label="CARI_ISIM" v-on:search="getCariList" placeholder="Taşımacı Cari" :loading="cariLoading"></v-select-list>
            </div>
            <div class="col-md-4 mb-1">
                <label class="form-label">Bitiş Firma</label>
                <v-select-list v-model="targetCari" :options="targetCariList" label="CARI_ISIM" v-on:search="getTargetCariList" placeholder="Bitiş Firma" :loading="targetCariLoading"></v-select-list>
            </div>
            <div class="col-md-4 mb-1">
                <label class="form-label">Stok</label>
                <v-select-list v-model="stok" :options="stoks" label="Name"  placeholder="Stok" :loading="stokLoading"></v-select-list>
            </div>
            <div class="col-md-4 mb-1">
                <label class="form-label">Şube</label>
                <v-select-list v-model="sube" :options="subeList" label="BranchName" placeholder="Şube"></v-select-list>
            </div>
            <div class="col-md-4 mb-1">
                <label class="form-label">Bölge</label>
                <v-select-list v-model="transferRegion" :options="transferRegionList" label="RegionName" placeholder="Bölge"></v-select-list>
            </div>
          
        </div>
    
        <div class="row justify-content-end">
            <div class="col-auto mb-1 mb-md-0">
                <v-executer :loading="filterLoading" :action="filter">Filtrele</v-executer>
            </div>
        </div>
        
        <div class="row mt-2">
            <div class="col-12">
                <h2>Seferler</h2>
                <div class="table-responsive">
                    <table class="table table-sm align-middle">
                        <thead>
                            <tr>
                                <th class="text-nowrap" style="width:40px">
                                    <!-- Başlıktaki checkbox: hiçbiri seçili değilse "hepsini seç",
                                         hepsi seçiliyse "hepsini kaldır". Karışık durumda indeterminate. -->
                                    <b-form-checkbox
                                        :checked="allSelected"
                                        :indeterminate="someSelected && !allSelected"
                                        v-on:change="toggleSelectAll">
                                    </b-form-checkbox>
                                </th>
                                <th>Sıra</th>
                                <th v-if="(createErrors || []).length">Bilgi</th>
                                <th class="text-nowrap">İrsaliye No</th>
                                <th class="text-nowrap">İşlemler</th>
                                <th class="text-nowrap">Tarih</th>
                                <th class="text-nowrap">Başlangıç Firma</th>
                                <th class="text-nowrap">Başlangıç Bölge</th>
                                <th class="text-nowrap">Bitiş Firma</th>
                                <th class="text-nowrap">Bitiş Bölge</th>
                                <th class="text-nowrap">Taşınan Ürün Adı</th>
                                <th class="text-nowrap">Taşınan Ürün Miktarı</th>
                                <th class="text-nowrap">Araç Tipi</th>
                                <th class="text-nowrap">Taşıma Durumu</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(data,index) in successSefers">
                                <tr :key="index" :class="{'table-active': isSelected(data.IrsaliyeNo)}">
                                    <td class="text-nowrap">
                                        <b-form-checkbox
                                            :checked="isSelected(data.IrsaliyeNo)"
                                            v-on:change="toggleSefer(data.IrsaliyeNo)">
                                        </b-form-checkbox>
                                    </td>
                                    <td class="text-nowrap">{{ index+1 }}</td>
                                    <td class="text-nowrap">
                                        <b-dropdown dropright size="sm" variant="light" no-caret>
                                             <template #button-content>
                                                <feather-icon class="mr-50" icon="MoreHorizontalIcon"></feather-icon>
                                                İşlemler
                                            </template>
                                            <b-dropdown-item  variant="primary"  v-on:click="updateTonnageModalOpen(data)">
                                                <feather-icon class="mr-50" icon="InfoIcon" size="16" ></feather-icon>
                                                Tonaj Güncelle
                                            </b-dropdown-item>
                                        </b-dropdown>

                                    </td>
                                    <td class="text-nowrap" v-if="(createErrors || []).length">
                                        <span class="material-icons-outlined d-block text-danger"  v-b-tooltip.noninteractive.hover.bottom :title="getError(data)" v-if="getError(data)">error_outline</span>
                                        <span class="material-icons-outlined text-success" v-else>check_circle</span>
                                    </td>
                                    <td class="text-nowrap">{{ data.IrsaliyeNo || '-' }}</td>
                                    <td class="text-nowrap">{{ data.Gun || '-' }}</td>
                                    <td class="text-nowrap" data-original-title="999" data-container="body" data-toggle="tooltip" data-placement="bottom" :title="data.BaslangicFirmaKodu">
                                        {{ data.BaslangicFirmaAdi || '-' }}
                                    </td>
                                    <td class="text-nowrap">{{ data.StartRegionName || '-' }} </td>

                                    <td class="text-nowrap" data-original-title="999" data-container="body" data-toggle="tooltip" data-placement="bottom" :title="data.BitisFirmaKodu" >
                                        {{ data.BitisFirmaAdi || '-' }}
                                    </td>
                                    <td class="text-nowrap">{{ data.EndRegionName || '-' }}</td>
                                    <td class="text-nowrap">{{ data.TasinanUrunAdi || '-' }}</td>
                                    <td class="text-nowrap">{{ data.TasinanUrunMiktariStr || '-' }}</td>
                                    <td class="text-nowrap">{{ data.AracTipiAdi || '-' }}</td>
                                    <td class="text-nowrap">{{ data.TasimaDurumu || '-' }}</td>
                                </tr>
                            </template>
                            <tr v-if="(successSefers || []).length == 0">
                                <td colspan="100" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- Seçim yardımcıları ve grup oluşturma butonu.
             Adamın senaryosu (3 tevkifatlı - 17 tevkifatsız):
             tümü seçili başlar → 3 tevkifatlı için grup oluştur →
             "Seçimi Tersine Çevir" → kalan 17 tevkifatsız için grup oluştur.
             Eskiden 40 el düzenlemesi (0,01 hilesi) gerekiyordu, artık iki tıkla bitiyor. -->
        <div class="row mt-2 align-items-center" v-if="(successSefers || []).length > 0">
            <div class="col-md-auto mb-1 mb-md-0">
                <span class="text-muted">
                    <feather-icon icon="CheckSquareIcon" class="mr-25"></feather-icon>
                    <strong>{{ selectedCount }}</strong> / {{ successSefers.length }} sefer seçili
                </span>
            </div>
            <div class="col-md-auto mb-1 mb-md-0">
                <b-button size="sm" variant="outline-primary" v-on:click="selectAll">
                    Tümünü Seç
                </b-button>
            </div>
            <div class="col-md-auto mb-1 mb-md-0">
                <b-button size="sm" variant="outline-secondary" v-on:click="clearSelection">
                    Seçimi Temizle
                </b-button>
            </div>
            <div class="col-md-auto mb-1 mb-md-0">
                <b-button size="sm" variant="outline-info" v-on:click="invertSelection">
                    <feather-icon icon="RefreshCwIcon" class="mr-25"></feather-icon>
                    Seçimi Tersine Çevir
                </b-button>
            </div>
            <div class="col text-right">
                <v-executer
                    :loading="createIrsaliyeLoading"
                    :action="createIrsaliyeGroup"
                    :disabled="selectedCount === 0">
                    Referans Grubu Oluştur ({{ selectedCount }})
                </v-executer>
            </div>
        </div>
        <div v-if="(errorSefers.length || [] ) > 0" class="row mt-2">
            <div class="col-12">
                <h2>Eksik Bilgisi Olan Seferler</h2>
                <div class="table-responsive">
                    <table class="table table-sm align-middle">
                        <thead>
                            <tr>
                                <th>Sıra</th>
                                <th class="text-nowrap">İrsaliye No</th>
                                <th class="text-nowrap">Tarih</th>
                                <th class="text-nowrap">Başlangıç Firma</th>
                                <th class="text-nowrap">Başlangıç Bölge</th>
                                <th class="text-nowrap">Bitiş Firma</th>
                                <th class="text-nowrap">Bitiş Bölge</th>
                                <th class="text-nowrap">Taşınan Ürün Adı</th>
                                <th class="text-nowrap">Taşınan Ürün Miktarı</th>
                                <th class="text-nowrap">Araç Tipi</th>
                                <th class="text-nowrap">Taşıma Durumu</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(data,index) in errorSefers">
                                <tr :key="index">
                                    <td>{{ index+1 }}</td>
                                    <td class="text-nowrap">{{ data.IrsaliyeNo || '-' }}</td>
                                    <td class="text-nowrap">{{ data.Gun || '-' }}</td>
                                    <td class="text-nowrap" data-original-title="999" data-container="body" data-toggle="tooltip" data-placement="bottom" :title="data.BaslangicFirmaKodu" >
                                        {{ data.BaslangicFirmaAdi || '-' }}
                                    </td>
                                    <td class="text-nowrap">{{ data.StartRegionName || '-' }} </td>
                                    <td class="text-nowrap" data-original-title="999" data-container="body" data-toggle="tooltip" data-placement="bottom" :title="data.BitisFirmaKodu" >
                                        {{ data.BitisFirmaAdi || '-' }}
                                    </td>
                                    <td class="text-nowrap">{{ data.EndRegionName || '-' }}</td>
                                    <td class="text-nowrap">{{ data.TasinanUrunAdi || '-' }}</td>
                                    <td class="text-nowrap">{{ data.TasinanUrunMiktariStr || '-' }}</td>
                                    <td class="text-nowrap">{{ data.AracTipiAdi || '-' }}</td>
                                    <td class="text-nowrap">{{ data.TasimaDurumu || '-' }}</td>
                                </tr>
                            </template>
                            <tr v-if="(errorSefers || []).length == 0">
                                <td colspan="100" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
import { BBadge, BButton, BCard, BFormCheckbox, BDropdown, BDropdownItem, BOverlay, VBTooltip } from 'bootstrap-vue'
import { NetsisApi } from '@/api/netsis'
import { TransferRegionApi } from '@/api/transfer-region'
import { MaterialApi } from '@/api/material'
import { IrsaliyeOperationsApi } from '@/api/irsaliye'
import moment from 'moment'
import VStatsBox from '@/components/VStatsBox.vue'
import UpdateTonnage from './components/UpdateTonnage.vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
export default {
    components:{
        BCard,
        BBadge,
        BButton,
        VStatsBox,
        BFormCheckbox,
        UpdateTonnage,
        BDropdown,
        BDropdownItem,
        BOverlay,
        FeatherIcon
    },
    directives:{
        "b-tooltip":VBTooltip
    },
    data(){
        return{
            UpdateTonnage:{
                IrsaliyeNo:null,
                Tonnage:null
            },
            queryData:{
                StartDate: moment().startOf('month').format('YYYY-MM-DD'),
                EndDate:moment().endOf('month').format("YYYY-MM-DD"),
                CariCode:null,
                CariName:null,
                TargetCariCode:null,
                StockCode:null,
                BranchCode:null,
                RegionCode:null
            },
            // Query data değişebilir ancak filtrelenmeyebilir. Filtrelenmediği zaman querydata
            // üzerinden ref. grup oluşursa hatalı bir çalışma olur (yanlış cari/tarih ile grup
            // açılır). Grup oluşturma da filteredData üzerinden yapılıyor artık; eskiden queryData
            // kullanılıyordu ve dropdown'ı filtreden sonra değiştiren kullanıcı yanlış cari adıyla
            // grup açabiliyordu (bkz. createIrsaliyeGroup).
            filteredData:{
                StartDate: moment().startOf('month').format('YYYY-MM-DD'),
                EndDate:moment().endOf('month').format("YYYY-MM-DD"),
                CariCode:null,
                CariName:null,
                TargetCariCode:null,
                StockCode:null,
                BranchCode:null
            },
            cariList:[],
            targetCariList:[],
            cariLoading:false,
            targetCariLoading:false,
            errorSefers:[],
            successSefers:[],
            // Kullanıcının işaretlediği irsaliye numaraları. Filtre çalıştığında yeni sonuçların
            // tamamı seçili gelir (adamın senaryosunda çoğunluk gruba dahil ediliyor, azınlığı
            // tersine çevirmek daha az iş). Vue 2 reactivity için data'da pre-declare şart.
            selectedIrsaliyeNos:[],
            stoks:[],
            filterLoading:false,
            stokLoading:false,
            createIrsaliyeLoading:false,
            subeList:[],
            subeLoading:false,
            transferRegionList:[],
            transferRegionLoading:false,
            createErrors:[],
            updateTonnageLoading:false
        }
    },
    mounted(){
        this.getSubeList()
        this.getRegionList()
        this.getStoks()
        // "Bekleyen Referans Grupları" ekranından gelen query param'lar varsa formu doldur
        // ve sorguyu otomatik çalıştır. Kullanıcı ekrana girdiğinde liste hazır, doğrudan
        // Referans Grubu Oluştur'a basabilir hale gelir.
        this.applyRouteQueryIfAny()
    },
    watch:{
        '$route.query': {
            deep: true,
            handler(){ this.applyRouteQueryIfAny() }
        }
    },
    methods:{
        updateTonnageModalOpen(item){
            this.UpdateTonnage.IrsaliyeNo = item.IrsaliyeNo
            this.UpdateTonnage.Tonnage = item.TasinanUrunMiktariStr
            this.$showModal('update-tonnage')
        },
        updateTonnage(){
            this.updateTonnageLoading = true
            this.successSefers = this.successSefers.map(item => {
                if (item.IrsaliyeNo === this.UpdateTonnage.IrsaliyeNo ) {
                return {
                    ...item,
                    TasinanUrunMiktari: Number(this.UpdateTonnage.Tonnage.replace(",", ".")),
                    TasinanUrunMiktariStr: this.UpdateTonnage.Tonnage.replace(",", ".")
                }
                }
                return item
            })
            this.updateTonnageLoading = false
            this.$hideModal('update-tonnage')
        },
        getRegionList(){
            this.transferRegionLoading = true
            TransferRegionApi.List().then(res =>{
                this.transferRegionList = res.data.Data
                this.transferRegionLoading =false
            }).catch(err => {
                this.transferRegionLoading =false
            })
        },
        getSubeList(){
            this.subeLoading = true
            NetsisApi.GetSubeList().then(res =>{
                if(res.data.Success){
                    this.subeList = res.data.Data
                }
                this.subeLoading = false
            }).catch(err=>{
                this.subeLoading = false
            })
        },
        filter(){
            this.createErrors=null
            this.filteredData.StartDate=this.queryData.StartDate
            this.filteredData.EndDate=this.queryData.EndDate
            this.filteredData.CariCode=this.queryData.CariCode
            // Grup oluştururken cari ADI da lazım; queryData'dan buraya taşınmazsa Create
            // yanlış (ya da eski) ada başvurur.
            this.filteredData.CariName=this.queryData.CariName
            this.filteredData.TargetCariCode=this.queryData.TargetCariCode
            this.filteredData.StockCode=this.queryData.StockCode
            this.filteredData.BranchCode=this.queryData.BranchCode
            this.filteredData.RegionCode = this.queryData.RegionCode
            this.filterLoading = true
            NetsisApi.GetSeferList(this.filteredData).then(res => {
                if(!res.data.Success){
                    this.$result(res)
                }else{
                    this.errorSefers = res.data.Data.ErrorSefers
                    this.successSefers = res.data.Data.SuccessSefers
                    // Yeni sonuçlar geldi: seçim varsayılan olarak "hepsi". Kullanıcı çoğunluğu
                    // gruba dahil etmek ister, azınlığı temizler veya tersine çevirir.
                    this.selectedIrsaliyeNos = (this.successSefers || []).map(s => s.IrsaliyeNo)
                }
                this.filterLoading = false
            }).catch(err=> {
                console.log(err)
                this.filterLoading = false
            })
        },
        getStoks(){
            this.stokLoading = true
            MaterialApi.List().then(res => {
                this.stoks = res.data.Data
                this.stokLoading = false
            }).catch(err=> {
                console.log(err)
                this.stokLoading = false
            })
        },
        getCariList(searchKey){
            if(searchKey){
                this.cariLoading = true
                NetsisApi.CariList(searchKey).then(res => {
                    this.cariList = res.data.Data
                    this.cariLoading = false
                }).catch(err=> {
                    console.log(err)
                    this.cariLoading = false
                })
            }
        },
        getTargetCariList(searchKey){
            if(searchKey){
                this.targetCariLoading = true
                NetsisApi.CariList(searchKey).then(res => {
                    this.targetCariList = res.data.Data
                    this.targetCariLoading = false
                }).catch(err=> {
                    console.log(err)
                    this.targetCariLoading = false
                })
            }
        },
        createIrsaliyeGroup(){
            if(this.selectedCount === 0){
                this.$result({data:{Success:false, Message:'Lütfen en az bir sefer seçin.'}})
                return
            }
            this.createIrsaliyeLoading = true
            // Sadece işaretlenmiş seferleri yolla. Kullanıcı hangi seferi hangi gruba koyacağını
            // ekrandaki seçimle söylüyor; tevkifatlı/tevkifatsız ayrımı buradan geçiyor.
            const selectedSet = new Set(this.selectedIrsaliyeNos)
            const sefersToSend = this.successSefers.filter(s => selectedSet.has(s.IrsaliyeNo))
            IrsaliyeOperationsApi.Create({
                // filteredData: Filtrele butonuna basıldığı anki değerler. queryData formdaki
                // canlı değerlerdir ve butondan sonra değişmiş olabilir; eskiden queryData'dan
                // okunuyordu ve dropdown'ı sonra değiştiren kullanıcı yanlış cari adıyla grup
                // açabiliyordu.
                CariCode:   this.filteredData.CariCode,
                CariName:   this.filteredData.CariName,
                // Şube ve bitiş firma da eskiden gönderilmiyordu; grup açılırken IrsaliyeGroup
                // satırının BranchCode/TargetCariCode alanları boş kalıyordu. Sonraki raporlar
                // ve mutabakat sayfası bunlara ihtiyaç duyacak.
                BranchCode: this.filteredData.BranchCode,
                TargetCariCode: this.filteredData.TargetCariCode,
                StartDate:  this.filteredData.StartDate,
                EndDate:    this.filteredData.EndDate,
                Sefers:     sefersToSend
            }).then(res =>{
                this.$result(res)
                this.createIrsaliyeLoading = false
                if(res.data.Success){
                    this.$router.push({name:'waybill-operations'})
                }else{
                    this.createErrors = res.data.Data
                }
            }).catch(err => {
                console.log(err)
                this.createIrsaliyeLoading = false
            })
        },
        // ---------- Seçim yardımcıları ----------
        isSelected(irsaliyeNo){
            return this.selectedIrsaliyeNos.includes(irsaliyeNo)
        },
        toggleSefer(irsaliyeNo){
            if(this.isSelected(irsaliyeNo)){
                this.selectedIrsaliyeNos = this.selectedIrsaliyeNos.filter(n => n !== irsaliyeNo)
            }else{
                this.selectedIrsaliyeNos = [...this.selectedIrsaliyeNos, irsaliyeNo]
            }
        },
        toggleSelectAll(checked){
            if(checked){
                this.selectAll()
            }else{
                this.clearSelection()
            }
        },
        selectAll(){
            this.selectedIrsaliyeNos = (this.successSefers || []).map(s => s.IrsaliyeNo)
        },
        clearSelection(){
            this.selectedIrsaliyeNos = []
        },
        // Adamın senaryosunun (3 tevkifatlı - 17 tevkifatsız) özgün cevabı: 3'ünü işaretle,
        // grup oluştur, "Tersine Çevir" ile 17'si seçili gelsin, ikinci grubu oluştur.
        invertSelection(){
            const currentSet = new Set(this.selectedIrsaliyeNos)
            this.selectedIrsaliyeNos = (this.successSefers || [])
                .map(s => s.IrsaliyeNo)
                .filter(no => !currentSet.has(no))
        },
        // "Bekleyen Referans Grupları" ekranı bu ekrana şu query string ile yönlendiriyor:
        //   ?cari=<TASIYICI_CARI_KOD>&cariAdi=<AD>&sube=<SUBE_KODU>&start=YYYY-MM-DD&end=YYYY-MM-DD
        // Cari dropdown'ı normalde arama ile yükleniyor; buradaysa kullanıcı henüz bir arama
        // yapmadığı için listede yok. Query'den gelen değerle bir stub obje kurup listeye ekliyoruz
        // ve queryData'ya set ediyoruz. Kullanıcı formu değiştirmezse Filtrele düğmesine
        // bile basmadan, mounted sonrası otomatik filter() ile liste hazır olur.
        applyRouteQueryIfAny(){
            const q = this.$route.query || {}
            if(!q.cari && !q.sube && !q.start && !q.end) return
            if(q.start) this.queryData.StartDate = q.start
            if(q.end)   this.queryData.EndDate   = q.end
            if(q.cari){
                this.queryData.CariCode = q.cari
                this.queryData.CariName = q.cariAdi || q.cari
                // Dropdown'ın seçilmiş görünmesi için listede olması gerek.
                if(!this.cariList.some(c => c.CARI_KOD === q.cari)){
                    this.cariList = [
                        { CARI_KOD: q.cari, CARI_ISIM: q.cariAdi || q.cari },
                        ...this.cariList
                    ]
                }
            }
            if(q.sube){
                this.queryData.BranchCode = q.sube
                if(!this.subeList.some(s => s.BranchCode === q.sube)){
                    this.subeList = [
                        { BranchCode: q.sube, BranchName: q.subeAdi || q.sube },
                        ...this.subeList
                    ]
                }
            }
            // Küçük bir gecikme: getSubeList/getStoks asenkron. Filtre değerleri zaten
            // set edildi, filter() bir tick sonra çağrılırsa Vue reactive'i güncellemiş olur.
            this.$nextTick(() => {
                if(this.queryData.CariCode){
                    this.filter()
                }
            })
        },
        getError(item){
            return this.createErrors?.filter(e=>e.IrsaliyeNo == item.IrsaliyeNo)?.map(a=> a.Error)?.join(', ') || null
        },
        getCurrentMonthDateRange(){
            let date = new Date();
            let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            return [firstDay,lastDay]
        },
    },
    computed:{
        // ---------- Seçim durumu ----------
        selectedCount(){
            return this.selectedIrsaliyeNos.length
        },
        allSelected(){
            return (this.successSefers || []).length > 0
                && this.selectedIrsaliyeNos.length === this.successSefers.length
        },
        someSelected(){
            return this.selectedIrsaliyeNos.length > 0
        },
        transferRegion:{
            get:function(){
                return this.transferRegionList.find(s=>s.RegionCode==this.queryData.RegionCode)
            },
            set:function(value){
                this.queryData.RegionCode = value?.RegionCode || null
            }
        },
        sube:{
            get:function(){
                return this.subeList.find(s=>s.BranchCode==this.queryData.BranchCode)
            },
            set:function(value){
                this.queryData.BranchCode = value?.BranchCode || null
            }
        },
        date:{
            get:function(){
                return [this.queryData.StartDate,this.queryData.EndDate].filter(d=>d != null)
            },
            set:function(val){
                this.queryData.StartDate = val[0] || null
                this.queryData.EndDate = val[1] || null
            }
        },
        cari:{
            get:function(){
                return this.cariList.find(s=>s.CARI_KOD==this.queryData.CariCode)
            },
            set:function(value){
                this.queryData.CariCode = value?.CARI_KOD || null
                this.queryData.CariName = value?.CARI_ISIM || null
            }
        },
        targetCari:{
            get:function(){
                return this.targetCariList.find(s=>s.CARI_KOD==this.queryData.TargetCariCode)
            },
            set:function(value){
                this.queryData.TargetCariCode = value?.CARI_KOD || null
            }
        },
        stok:{
            get:function(){
                return this.stoks.find(s=>s.Id==this.queryData.Id)
            },
            set:function(value){
                this.queryData.StockCode = value?.Code || null
            }
        }
    }
}
</script>

<style>

</style>